import React, { useEffect, useState } from "react";
import { TreeSelect } from "antd";
import 'antd/dist/antd.min.css';

function makeChild(childs) {
    if (childs.length > 0) {
        let data = childs.map((item) => {
            return {
                title: item.name,
                value: item.id,
                key: item.id,
                children: makeChild(item.children),
            };
        });
        return data;
    }
    return;
}

function TreeSelectComponent(props) {
    const [treeDataList, setTreeDataList] = useState([]);
    const [state, setState] = useState(null);

    const onChange = (value) => {
        setState(value);
    };

    useEffect(() => {
        let data = props.tree.map((item) => {
            return {
                title: item.name,
                value: item.id,
                key: item.id,
                pId:0,
                children: makeChild(item.children),
            };
        });
        setTreeDataList(data);
        setState(props.treeSelectedId);
        return () => {
            setTreeDataList([]);
        };
    }, [props.tree]);

    return (
        <TreeSelect
            disabled={props.disable}
            style={{ width: "100%" }}
            value={state}
            dropdownStyle={{ maxHeight: 400, overflow: "auto" }}
            treeData={treeDataList}
            placeholder="Please select..."
            treeDataSimpleMode
            multiple={props.multiple}
            onChange={(value) => {
                setState(value);
                props.onChange(value);
            }}
        />
    );
}

export default TreeSelectComponent;
